import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO from '../components/SEO';
import ProductCard from '../components/ProductCard';
import TrendingCard from '../components/TrendingCard';
import apiClient from '../utils/apiClient';
import '../styles/ShopCategory.css';

// Default configuration fallbacks for each category
const defaultCategoryConfig = {
    stationary: {
        title: 'Stationary',
        subtitle: 'Premium Office & Art Supplies',
        bannerImage: 'https://images.unsplash.com/photo-1584628804572-f84284d9f388?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        subCategories: [
            { name: 'Notebooks', image: 'https://plus.unsplash.com/premium_photo-1667251758255-514ef43844fb?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', filter: 'notebooks' },
            { name: 'Pens & Pencils', image: 'https://images.unsplash.com/photo-1585336261022-680e295ce3fe?q=80&w=300&auto=format&fit=crop', filter: 'pens' },
            { name: 'Art Supplies', image: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?q=80&w=300&auto=format&fit=crop', filter: 'art' },
            { name: 'Desk Organizers', image: 'https://images.unsplash.com/photo-1644463589256-02679b9c0767?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', filter: 'organizers' },
            { name: 'Gift Wrapping', image: 'https://images.unsplash.com/photo-1513885535751-8b9238bd345a?q=80&w=300&auto=format&fit=crop', filter: 'wrapping' },
        ]
    },
    textiles: {
        title: 'Textiles & Fabrics',
        subtitle: 'Authentic Handloom & Fabrics',
        bannerImage: 'https://images.unsplash.com/photo-1722694583723-b75de0918c44?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        subCategories: [
            { name: 'Sarees', image: 'https://images.unsplash.com/photo-1727430228383-aa1fb59db8bf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8c2FyZWV8ZW58MHx8MHx8fDA%3D', filter: 'saree' },
            { name: 'Kurtas', image: 'https://images.unsplash.com/photo-1731577506253-0fd9cd00ab7f?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', filter: 'kurta' },
            { name: 'Fabrics', image: 'https://images.unsplash.com/photo-1601056639638-c53c50e13ead?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8RmFicmljc3xlbnwwfHwwfHx8MA%3D%3D', filter: 'fabric' },
            { name: 'Dupattas', image: 'https://images.unsplash.com/photo-1680506660555-1c225f5da953?q=80&w=764&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', filter: 'dupatta' },
        ]
    },
    pottery: {
        title: 'Pottery & Ceramics',
        subtitle: 'Handcrafted Clay & Ceramic Art',
        bannerImage: 'https://images.unsplash.com/photo-1493106641515-6b5631de4bb9?q=80&w=1920&auto=format&fit=crop',
        subCategories: [
            { name: 'Vases', image: 'https://images.unsplash.com/photo-1597696929736-6d13bed8e6a8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8VmFzZXN8ZW58MHx8MHx8fDA%3D', filter: 'vase' },
            { name: 'Dinnerware', image: 'https://images.unsplash.com/photo-1594404895374-f89ce340ae38?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjI1fHxkaW5uZXJ3YXJlfGVufDB8fDB8fHww', filter: 'dinnerware' },
            { name: 'Planters', image: 'https://images.unsplash.com/photo-1485955900006-10f4d324d411?q=80&w=300&auto=format&fit=crop', filter: 'planter' },
            { name: 'Mugs', image: 'https://plus.unsplash.com/premium_photo-1719289718424-0f5071da5a3a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8bXVnc3xlbnwwfHwwfHx8MA%3D%3D', filter: 'mug' },
        ]
    },
    handicrafts: {
        title: 'Handicrafts',
        subtitle: 'Traditional Indian Craftsmanship',
        bannerImage: 'https://images.unsplash.com/photo-1652355056810-ce141db641d9?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        subCategories: [
            { name: 'Wooden Crafts', image: 'https://plus.unsplash.com/premium_photo-1678752717582-f46bb39890c4?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', filter: 'wood' },
            { name: 'Metal Art', image: 'https://images.unsplash.com/photo-1652164726284-2e82259cddfc?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', filter: 'metal' },
            { name: 'Paintings', image: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?q=80&w=300&auto=format&fit=crop', filter: 'painting' },
            { name: 'Masks', image: 'https://images.unsplash.com/photo-1745429806387-6224c9940799?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDJ8fG1hc2t8ZW58MHx8MHx8fDA%3D', filter: 'mask' },
        ]
    },
    electronics: {
        title: 'Electronics',
        subtitle: 'Modern Gadgets & Accessories',
        bannerImage: 'https://images.unsplash.com/photo-1550009158-9ebf69173e03?q=80&w=1920&auto=format&fit=crop',
        subCategories: [
            { name: 'Audio', image: 'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8aGVhZHBob25lc3xlbnwwfHwwfHx8MA%3D%3D', filter: 'audio' },
            { name: 'Accessories', image: 'https://images.unsplash.com/photo-1693279504914-d08266ecbe66?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', filter: 'accessories' },
            { name: 'Smart Home', image: 'https://images.unsplash.com/photo-1730967844913-29eb5cae5f34?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', filter: 'smart' },
        ]
    },
    'home-decor': {
        title: 'Home Decor',
        subtitle: 'Beautify Your Living Space',
        bannerImage: 'https://images.unsplash.com/photo-1513519245088-0e12902e5a38?q=80&w=1920&auto=format&fit=crop',
        subCategories: [
            { name: 'Wall Art', image: 'https://images.unsplash.com/photo-1452457005517-a0dd81caca2a?q=80&w=1095&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', filter: 'wall' },
            { name: 'Lighting', image: 'https://images.unsplash.com/photo-1540932239986-30128078f3c5?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzF8fGxpZ2h0aW5nfGVufDB8fDB8fHww', filter: 'light' },
            { name: 'Cushions', image: 'https://plus.unsplash.com/premium_photo-1764329347430-7330d2e62713?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fHw%3D', filter: 'cushion' },
            { name: 'Rugs', image: 'https://plus.unsplash.com/premium_photo-1725621529322-7215550871ce?q=80&w=1169&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', filter: 'rug' },
        ]
    }
};

const ShopCategory = () => {
    const { category } = useParams();
    const [featuredProducts, setFeaturedProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [categoryConfig, setCategoryConfig] = useState(null);

    const normalizedCategory = category ? category.toLowerCase() : '';

    // Fetch category configuration from API
    useEffect(() => {
        const abortController = new AbortController();

        const fetchCategoryConfig = async () => {
            try {
                // Reset state when category changes
                setCategoryConfig(null);
                setFeaturedProducts([]);
                setLoading(true);

                const response = await apiClient.get(`/trending/category-config/${normalizedCategory}`, {
                    signal: abortController.signal
                });
                if (response.data.config) {
                    setCategoryConfig(response.data.config);
                }
            } catch (error) {
                if (error.name === 'CanceledError' || error.name === 'AbortError') {
                    // Request was cancelled, ignore
                    return;
                }
                console.error('Error fetching category config:', error);
                // Will use fallback defaults
            }
        };

        if (normalizedCategory) {
            fetchCategoryConfig();
        }

        // Cleanup: abort request if category changes before response
        return () => {
            abortController.abort();
        };
    }, [normalizedCategory]);

    // Get config - API config takes priority, then defaults, then generic
    const getConfig = () => {
        if (categoryConfig) {
            return categoryConfig;
        }
        if (defaultCategoryConfig[normalizedCategory]) {
            return defaultCategoryConfig[normalizedCategory];
        }
        return {
            title: category ? category.charAt(0).toUpperCase() + category.slice(1) : 'Category',
            subtitle: 'Explore our collection',
            bannerImage: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?q=80&w=1920&auto=format&fit=crop',
            subCategories: []
        };
    };

    const config = getConfig();

    useEffect(() => {
        const abortController = new AbortController();

        const fetchFeaturedProducts = async () => {
            try {
                setLoading(true);

                // Check if we have configured trending products
                if (categoryConfig?.trendingProducts && categoryConfig.trendingProducts.length > 0) {
                    // Fetch products by IDs from the configured trending list
                    const productIds = categoryConfig.trendingProducts.map(p => p.id);
                    const response = await apiClient.post('/products/by-ids', { ids: productIds }, {
                        signal: abortController.signal
                    });

                    // Maintain the configured order
                    const products = response.data.products || [];
                    const orderedProducts = productIds
                        .map(id => products.find(p => p.id === id))
                        .filter(Boolean);

                    setFeaturedProducts(orderedProducts);
                } else {
                    // Fallback: Fetch random products from this category
                    const response = await apiClient.get(`/products?category=${normalizedCategory}&limit=8`, {
                        signal: abortController.signal
                    });
                    setFeaturedProducts(response.data.products || []);
                }
            } catch (error) {
                // Ignore cancelled requests
                if (error.name === 'CanceledError' || error.name === 'AbortError') {
                    return;
                }
                console.error('Error fetching category products:', error);
                // Fallback on error
                try {
                    const response = await apiClient.get(`/products?category=${normalizedCategory}&limit=8`, {
                        signal: abortController.signal
                    });
                    setFeaturedProducts(response.data.products || []);
                } catch (e) {
                    if (e.name !== 'CanceledError' && e.name !== 'AbortError') {
                        console.error('Fallback also failed:', e);
                    }
                }
            } finally {
                // Only set loading false if not aborted
                if (!abortController.signal.aborted) {
                    setLoading(false);
                }
            }
        };

        fetchFeaturedProducts();
        window.scrollTo(0, 0);

        // Cleanup: abort requests if category changes
        return () => {
            abortController.abort();
        };
    }, [category, normalizedCategory, categoryConfig]);

    return (
        <div className="shop-category-page">
            <SEO
                title={`${config.title} - Shop Authentic Crafts`}
                description={`Shop ${config.title.toLowerCase()} - ${config.subtitle}. Discover authentic handmade products crafted by skilled artisans.`}
                canonical={`https://kalingastore.shop/shop/${normalizedCategory}`}
                breadcrumbs={[
                    { name: 'Home', url: 'https://kalingastore.shop/' },
                    { name: config.title, url: `https://kalingastore.shop/shop/${normalizedCategory}` },
                ]}
            />
            {/* Hero Banner */}
            <div
                className="category-hero"
                style={{ backgroundImage: `url(${config.bannerImage})` }}
            >
                <div className="hero-content">
                    <h1>{config.title}</h1>
                    <p>{config.subtitle}</p>
                </div>
            </div>

            {/* Shop by Category */}
            {config.subCategories && config.subCategories.length > 0 && (
                <section className="shop-section">
                    <h2 className="section-title">Shop by Category</h2>
                    <div className="sub-categories-grid">
                        {config.subCategories.map((sub, index) => (
                            <Link
                                to={`/products?category=${category}&search=${sub.filter}`}
                                key={index}
                                className="sub-category-card"
                            >
                                <div className="sub-cat-image-container">
                                    <img src={sub.image} alt={sub.name} />
                                </div>
                                <span>{sub.name}</span>
                            </Link>
                        ))}
                    </div>
                </section>
            )}

            {/* Trending Section */}
            <section className="shop-section trending-section">
                <h2 className="section-title">Trending in {config.title}</h2>
                {loading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading Trending Products...</p>
                    </div>
                ) : (
                    <div className="trending-grid">
                        {featuredProducts.length > 0 ? (
                            featuredProducts.map(product => (
                                <TrendingCard key={product.id} product={product} />
                            ))
                        ) : (
                            <p>No products found in this category.</p>
                        )}
                    </div>
                )}
            </section>

            {/* View All Link */}
            <div className="view-all-container">
                <Link to={`/products?category=${category}`} className="view-all-btn">
                    View All {config.title}
                </Link>
            </div>
        </div>
    );
};

export default ShopCategory;
